<div class="layout-mapa maps-{{ cantMapas }}">
  @for (idx of getMapIndices(); track trackByIndex($index); let i = $index) {
    <div
      class="map-container"
      [class.selected]="isSelected(i)"
      (click)="onMapContainerClick(i)"
      role="button"
      aria-label="Seleccionar mapa {{ i + 1 }}"
      tabindex="0"
      (keydown.enter)="onMapContainerClick(i)"
    >
      <!-- Contenedor del mapa -->
      <div [id]="'map' + i" class="map-instance"></div>

      <!-- Controles flotantes de dibujo (solo en el mapa seleccionado) -->
      @if (isSelected(i) && seleccionadoBarraLateral?.puedeDibujar) {
        <div class="flotante">
          <div class="row-flex-start" style="gap: 8px">
            @if (dibujandoEnMapaSeleccionado) {
              <!-- En modo edición: botón para terminar -->
              <button
                irxBoton="tonal"
                style="margin-left: 0.5em"
                type="button"
                (click)="desactivarModoEdicion()"
              >
                <mat-icon>done</mat-icon>
                Terminar edición
              </button>
            } @else if (tieneCirculoDibujado) {
              <!-- Hay círculo pero no editable: botón editar -->
              <button
                irxBoton="tonal"
                style="margin-left: 0.5em"
                type="button"
                (click)="dibujar()"
              >
                <mat-icon>edit</mat-icon>
                Editar
              </button>
            } @else {
              <!-- No hay círculo: botón dibujar -->
              <button
                irxBoton="tonal"
                style="margin-left: 0.5em"
                type="button"
                (click)="dibujar()"
              >
                Dibujar
              </button>
            }
            <button
              irxBotonIcono="mapa" tooltip="Eliminar"
              tono="peligro"
              type="button"
              (click)="borrarDibujos()"
              [disabled]="!tieneCirculoDibujado && !dibujandoEnMapaSeleccionado"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }

      @if (
        isSelected(i) &&
        seleccionadoBarraLateral?.puedeDibujarRecorrido &&
        seleccionadoBarraLateral?.seleccionadosVehiculosRecorridos
          ?.busquedaRealizada?.centrar &&
        seleccionadoBarraLateral?.seleccionadosVehiculosRecorridos
          ?.busquedaRealizada?.polylines.length > 0
      ) {
        <!-- Reproductor del viaje: todos los controles juntos abajo, como el de
             un video. La línea de tiempo va al medio, con la hora del punto que
             se está viendo a la izquierda y la de fin a la derecha. Sin traza
             dibujada no aparece: los controles y el recorrido van juntos. -->
        @if (instanciaViaje; as instancia) {
          @if (instancia.tripCoords?.length) {
            <div class="reproductor">
              <!-- Play / Pausa -->
              <button
                irxBotonIcono="borde"
                tono="primario"
                (click)="toggleAnimationOnSelected()"
                [disabled]="!puedeAnimar"
                [tooltip]="
                  !puedeAnimar
                    ? 'La reproducción necesita un solo mapa en la vista'
                    : instancia.animating
                      ? 'Pausa'
                      : 'Play'
                "
              >
                <mat-icon>
                  {{ instancia.animating ? 'pause' : 'play_arrow' }}
                </mat-icon>
              </button>

              <!-- Stop: corta la animación y la deja lista desde el inicio -->
              <button
                irxBotonIcono
                (click)="stopAnimationOnSelected()"
                [disabled]="!puedeAnimar"
                tooltip="Detener"
              >
                <mat-icon>stop</mat-icon>
              </button>

              <!-- Línea de tiempo: la hora sale de los reportes del viaje, así
                 que es aproximada entre uno y otro. El valor de la barra lo
                 escribe el loop de la animación directo sobre el input, sin
                 pasar por el binding de Angular. -->
              <span class="reproductor-fecha" #fechaProgreso>
                --/-- --:--:--
              </span>
              <div class="custom-slider progreso-slider">
                <input
                  #progresoViaje
                  [disabled]="!puedeAnimar"
                  type="range"
                  min="0"
                  max="1000"
                  step="1"
                  value="0"
                  (input)="onProgresoInput()"
                  tooltip="Progreso del recorrido"
                  aria-label="Progreso del recorrido"
                />
              </div>
              <span
                class="reproductor-fecha reproductor-fecha-fin"
                #fechaFinViaje
              >
                --/-- --:--:--
              </span>

              <!-- Velocidad de la reproducción -->
              <div class="reproductor-velocidad">
                <mat-icon tooltip="Velocidad de la reproducción">
                  speed
                </mat-icon>
                <div class="custom-slider">
                  <input
                    type="range"
                    min="0"
                    max="3000"
                    step="50"
                    [(ngModel)]="speed"
                    (ngModelChange)="onSpeedChange($event)"
                    aria-label="Velocidad animación"
                  />
                </div>
              </div>

              <!-- Color de lo que muestra el play: traza y punto. El input
                 nativo no puede ir adentro del botón (HTML no permite anidar
                 controles): queda escondido al lado y lo abre el botón. -->
              <button
                irxBotonIcono
                class="reproductor-color"
                (click)="selectorColor.click()"
                tooltip="Color del recorrido en vivo"
              >
                <mat-icon>palette</mat-icon>
              </button>
              <input
                #selectorColor
                type="color"
                class="selector-color-oculto"
                [(ngModel)]="colorReproduccion"
                (change)="onColorReproduccionChange()"
                aria-label="Color del recorrido en vivo"
              />
            </div>
          }
        }
      }
    </div>
  }
</div>
